import { render } from "./CrawlOptions.vue?vue&type=template&id=6f2036a5&scoped=true"
import script from "./CrawlOptions.vue?vue&type=script&lang=js"
export * from "./CrawlOptions.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6f2036a5"

export default script